import Vue from 'vue'
import router from './router'
import store from './store'
import App from './pages/App.vue'
import i18n from './i18n'

import './assets/scss/app.scss'

Vue.router = router
Vue.config.productionTip = false

new Vue({
    el: "#app",
    router: router,
    store: store,
    i18n,
    render: h => h(App)
})
